import React from 'react'
import Title from '../../title/title.jsx'

const Ergoterapi = () => {
  return (
    <div>Ergoterapi</div>
  )
}

export default Ergoterapi